exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.voorwaarden{max-width:650px;padding-top:30px;padding-bottom:30px;margin:auto}li{font-size:18px;padding:10px;font-family:Arial,Helvetica,sans-serif}.align-right{text-align:right}h1,h3{font-family:Bitter}table{font-family:arial,sans-serif;border-collapse:collapse;width:100%;margin:20px 0}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(2n){background-color:#f2dcdd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eaad4bb","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Voorwaarden.vue
// module id = 75
// module chunks = 0